import { Dispatch, SetStateAction } from "react";
import { ApiResponse } from "../models/ApiResponse";
import { ProductAssignments, ProductAssignmentsResponse } from "../pages/Products/AssignmentList";
import { initialProductAssignmentsListRequest } from "../reducers/productAssignmentReducer";
import api from "../services/ApiService";
import { UserAssignmentFieldValue } from "./UserAssignments";

export const fetchUserAssignmentsFromBaseCode = (
    formValueBaseCode: string, 
    setSelectedUserAssignments: Dispatch<SetStateAction<UserAssignmentFieldValue[]>>, 
    setUserAssignmentsApiRunning: Dispatch<SetStateAction<boolean>>,
    setIsFetchAssignmentsFailed?: Dispatch<SetStateAction<boolean>>,
  ) => {
    if(formValueBaseCode?.trim()) {
      setUserAssignmentsApiRunning(true);
      api
          .post<ApiResponse<ProductAssignmentsResponse>>("/Assignment/product-assignment/list", {
            ...initialProductAssignmentsListRequest,
            baseCode: formValueBaseCode
          },
          {
            headers: {
              disableLoader: true
            }
          })
          .then(async (response) => {
              if (response.isSuccess) {
                  let productAssignments: ProductAssignments[] = (response?.data?.productAssignments || []);
                  if (productAssignments?.length > 0) {
                      productAssignments = productAssignments.map((pa) => {
                          const uniqueAssignments = [];
                          if (pa.userAssignments?.length > 0) {
                              pa.userAssignments.map(ua => {
                                  // remove duplicate id records
                                  if (!uniqueAssignments.find(item => item.id === ua.id)?.id) {
                                      uniqueAssignments.push(ua);
                                  }
                              });
                          }
                          return {
                              ...pa,
                              userAssignments: uniqueAssignments
                          };
                      });
                      const selectedUA = productAssignments[0]?.userAssignments?.map(ua => {
                        return {
                          id: ua.id,
                          userId: ua.userId,
                          assignmentId: ua.assignmentId
                        }
                      });
                      setSelectedUserAssignments(selectedUA);
                  } else {
                    setSelectedUserAssignments([]);
                  }
                  if(setIsFetchAssignmentsFailed) {
                      setIsFetchAssignmentsFailed(false);
                  }
                } else {
                  console.error("Exception from product assignments");
                  if(setIsFetchAssignmentsFailed) {
                      setIsFetchAssignmentsFailed(true);
                  }
              }
              setUserAssignmentsApiRunning(false);
          })
          .catch((error) => {
              console.error("Exception from product assignments", error);
              if(setIsFetchAssignmentsFailed) {
                  setIsFetchAssignmentsFailed(true);
                  setUserAssignmentsApiRunning(false);
              }
            });
    }
  };